import {makeAutoObservable} from 'mobx';
import BusinessRecordAgent from '../agent/business-record-agent';
import {BusinessRecordDto} from '../../entity/dto/business-record-dto';
import {BusinessRecord} from '../../entity/model/business-record';
import {RequestBody} from '../../entity/core/request-body';

export default class BusinessRecordStore {
  businessRecordAgent: BusinessRecordAgent;

  constructor(businessRecordAgent: BusinessRecordAgent) {
    makeAutoObservable(this);
    this.businessRecordAgent = businessRecordAgent;
  }

  createBusinessRecords = async (payload: BusinessRecordDto[]): Promise<BusinessRecord[] | string> => {
    try {
      const requestBody: RequestBody = { body: payload };
      return await this.businessRecordAgent.createBusinessRecords(requestBody);
    } catch (error: any) {
      console.error('An error occurred while submitting title services !!', error);
      return 'An error occurred while submitting title services. Please try again.';
    }
  }
}
